import styled from "@emotion/styled";

import { theme } from "../../../../Controls/Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const FiltersRow = styled.div(() => ({
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "16px",
}));

export const FiltersCol = styled.div<{ size: number }>(props => ({
    flexBasis: 0,
    flexShrink: 0,
    flexGrow: props.size,
    marginRight: "16px",
}));

export const FiltersHint = styled.span(props => ({
    color: theme(props).typography.secondary.color,
}));

export const FilterTitle = styled.div(() => ({
    paddingTop: "4px",
}));
